import React from 'react'
import ZahtjevInput from '../../containers/ZahtjevInput/ZahtjevInput'
import Naslov from '../../components/Naslov/Naslov'

const zahtjevInputLayout = (props) => {
  return (
    <>
      <Naslov naslov="Zahtjev za predaju dokumentacije" />
        <ZahtjevInput />
    </>
  )
}

export default zahtjevInputLayout
